
import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, setDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { initializeAppCheck, ReCaptchaV3Provider, getToken as getAppCheckToken } from "firebase/app-check";

// --- Firebase config ---
const firebaseConfig = {
  apiKey: "AIzaSyDcjUhZ7GQb3lOeeoufh7YYRk3J8l3crQM",
  authDomain: "apnaghar-abb6a.firebaseapp.com",
  projectId: "apnaghar-abb6a",
  storageBucket: "apnaghar-abb6a.firebasestorage.app",
  messagingSenderId: "446361307066",
  appId: "1:446361307066:web:21b188da4bedb9001d7f83",
  measurementId: "G-ZTZ12VYDVV"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);

// Core services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// --- App Check ---


const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6LfyyxosAAAAAMXOAc5CmNlnFDUf_jeCfSE_GDW-"),
  isTokenAutoRefreshEnabled: true
});

// ✅ Helper to log App Check token
async function logAppCheckToken() {
  try {
    const token = await getAppCheckToken(appCheck, true); // force refresh
    console.log("✅ App Check token:", token?.token);
    return token?.token;
  } catch (err) {
    console.error("❌ Failed to get App Check token:", err);
    return null;
  }
}

// --- Messaging setup ---
let messaging = null;
isSupported().then((supported) => {
  if (supported) {
    messaging = getMessaging(app);
    console.log("✅ FCM supported in this browser.");
  } else {
    console.warn("⚠️ FCM is not supported in this browser.");
  }
});

// Listen for foreground messages
function listenForegroundNotifications() {
  if (!messaging) return;
  onMessage(messaging, (payload) => {
    console.log("📩 Foreground notification:", payload);
    const { title, body, icon } = payload.notification || {};
    if (Notification.permission === "granted" && (title || body)) {
      new Notification(title || "New message", { body: body || "", icon: icon || "/icon-192.png" });
    }
  });
}

// --- FCM token helper ---
async function getFcmToken() {
  if (!messaging) return null;
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return null;

    const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY || ""; 
    return await getToken(messaging, { vapidKey });
  } catch (err) {
    console.error("❌ Error getting FCM token:", err);
    return null;
  }
}

// --- Auth State Listener ---
onAuthStateChanged(auth, async (user) => {
  if (!user) return console.warn("⚠️ No user is signed in.");

  console.log("👤 Authenticated user:", user.uid);

  try {
    await logAppCheckToken(); // wait for App Check token
    const token = await getFcmToken();
    if (token) {
      await setDoc(doc(db, "user-data", user.uid), { fcmToken: token }, { merge: true });
      console.log("✅ FCM token saved in Firestore");
    }
  } catch (err) {
    console.error("❌ Failed during auth state listener:", err);
  }
});

// --- Export ---
export {
  app,
  auth,
  db,
  storage,
  messaging,
  getFcmToken,
  listenForegroundNotifications,
  appCheck,
  logAppCheckToken
};
